import { useLocalCacheClear } from "@app/hooks/useLocalCacheClear";
import { useLogout } from "@app/hooks/useUser";
import type { UserDetails } from "@app/interfaces/UserDetails";
import { useState } from "react";

export const ProfileMenu = ({
	user,
	csvData,
}: {
	user: UserDetails | null;
	csvData: string;
}) => {
	const [open, setOpen] = useState(false);

	const localCacheClear = useLocalCacheClear();

	const logout = useLogout();

	async function clickLogout() {
		setOpen(false);
		logout.mutate();
		await localCacheClear(false);
	}

	async function clickClearCache() {
		setOpen(false);
		await localCacheClear(true);
	}

	function clickCapsuleProfile() {
		setOpen(false);
		window.open("https://chartistechnology.capsulecrm.com/preferences");
	}

	return (
		<div className="profile-menu">
			<button
				type={"button"}
				onClick={() => setOpen((prev) => !prev)}
				className={"button-div"}
			>
				<img
					className={"profile-button"}
					src={
						user == null || user.pictureURL == null
							? "/profile_logo.png"
							: user.pictureURL
					}
					alt={"profile"}
				/>
			</button>
			{open && (
				<div className={"profile-menu-list"}>
					<button
						type="button"
						className={"profile-menu-item"}
						onClick={clickCapsuleProfile}
					>
						Capsule Profile
					</button>
					<a
						className="profile-menu-item"
						download="report.csv"
						onClick={() => setOpen(false)}
						href={`data:text/csv;charset=UTF-8,${encodeURIComponent(csvData)}`}
					>
						Export CSV Summary
					</a>
					<button
						type="button"
						className={"profile-menu-item"}
						onClick={clickClearCache}
					>
						Clear Local Cache
					</button>
					<button
						type="button"
						className={"profile-menu-item"}
						onClick={clickLogout}
					>
						Log Out
					</button>
				</div>
			)}
		</div>
	);
};
